import numeral from "numeral"

export const ZERO_PRICE = "$0.00"

export const formatUSD = (
  value: string | number,
  inputString = "0.[00]a",
): string => {
  if (typeof value === "string") value = Number(value)
  if (value === 0) return "$0.00"
  if (value < 0.000001) return "<$0.01"

  return `$${numeral(value).format(inputString).toUpperCase()}`
}
